import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { Utils } from "../../utils/utils";
import { ExportService } from "../../services/export/export.service";
import { RiskIndicator } from "../../interfaces/riskIndicator";
import { RiskIndicatorService } from "../../services/risk-indicator/risk-indicator.service";
import { Project } from "../../interfaces/project";
import { ProjectService } from "../../services/project/project.service";
import { MzToastService } from "ng2-materialize";
import { RetrospectiveService } from "../../services/retrospective/retrospective.service";
import { chartColorScheme } from "../../utils/chartColortScheme";

@Component({
  selector: "app-risk-indicator",
  templateUrl: "./risk-indicator.component.html",
  styleUrls: ["./risk-indicator.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskIndicatorComponent implements OnInit {
  readonly env: any = environment;
  readonly utils: any = Utils;

  loading: boolean;
  allRiskIndicators: RiskIndicator[];
  riskIndicator: RiskIndicator;
  project: Project;
  indicatorData: any;
  indicatorLineData: any;
  visibleChart: string = "boxplot";
  chartColorScheme = chartColorScheme;

  constructor(
    private projectService: ProjectService,
    private toastService: MzToastService,
    private riskIndicatorService: RiskIndicatorService,
    private retrospectiveService: RetrospectiveService,
    private changeDetector: ChangeDetectorRef,
    private route: ActivatedRoute,
    private exportService: ExportService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(
      async (params: { id: string; riskIndicatorId: string }) => {
        this.loading = true;
        this.project = await this.projectService.getProjectByShortId(params.id);

        this.allRiskIndicators = await this.riskIndicatorService.getRiskIndicatorsByProjectId(
          this.project._id
        );
        this.riskIndicator = this.allRiskIndicators.find(
          (r) => r.shortId === params.riskIndicatorId
        );
        // this.riskIndicator = await this.riskIndicatorService.getRiskIndicatorByShortId(params.riskIndicatorId);

        let retrospectives = (
          await this.retrospectiveService.getByProjectId(this.project._id)
        ).sort(
          (x, y) =>
            new Date(x.created_at).getTime() - new Date(y.created_at).getTime()
        );

        if (
          retrospectives.filter(
            (x) =>
              x.votings.filter(
                (y) => y.riskIndicatorId === this.riskIndicator._id
              ).length > 0
          ).length > 0
        ) {
          let retrospectiveData = retrospectives
            .filter(
              (x) =>
                x.votings.filter(
                  (y) => y.riskIndicatorId === this.riskIndicator._id
                ).length > 0
            )
            .map((x) => {
              return {
                name:
                  x.name +
                  " (" +
                  new Date(x.created_at).toLocaleDateString("de-DE") +
                  ")",
                values: x.votings
                  .filter(
                    (y) => y.riskIndicatorId === this.riskIndicator._id
                  )[0]
                  .participants.map((y) => Number(y.estimation)),
              };
            });

          this.indicatorData = {
            name: this.riskIndicator.name,
            series: retrospectiveData,
          };

          this.indicatorLineData = [
            {
              name: "Mittelwert",
              series: retrospectiveData.map((x) => {
                return {
                  name: x.name,
                  value: this.calcAverage(x.values.filter((y) => y || y === 0)),
                };
              }),
            },
            {
              name: "Median",
              series: retrospectiveData.map((x) => {
                return {
                  name: x.name,
                  value: this.calcMedian(x.values.filter((y) => y || y === 0)),
                };
              }),
            },
          ];

          console.log(this.indicatorLineData);
        } else {
          this.indicatorData = null;
          this.indicatorLineData = null;
        }
        this.loading = false;
        this.changeDetector.detectChanges();
      }
    );
  }

  calcAverage(values: number[]): number {
    if (values.length === 0) return 0;
    var sum = values.reduce(function (a, b) {
      return a + b;
    });
    return sum / values.length;
  }

  calcMedian(values: number[]): number {
    values.sort(function (a, b) {
      return a - b;
    });

    if (values.length === 0) return 0;

    var half = Math.floor(values.length / 2);

    if (values.length % 2) return values[half];
    else return (values[half - 1] + values[half]) / 2.0;
  }

  async update(riskIndicator) {
    try {
      await this.riskIndicatorService.saveRiskIndicator(riskIndicator);
    } catch (res) {
      console.log(res);
      this.toastService.show(
        "Fehler! Nicht Gespeichert",
        4000,
        "notification-toast"
      );
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/risk-indicator/risk-indicator.component.ts